package one.healthium.log_food.ui

import androidx.compose.foundation.layout.Column
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import com.arkivanov.decompose.extensions.compose.stack.Children
import com.arkivanov.decompose.extensions.compose.stack.animation.slide
import com.arkivanov.decompose.extensions.compose.stack.animation.stackAnimation
import loco.LOG_FOOD_ADD_MEAL_SCREEN_TITLE
import one.healthium.log_food.ui.add_food.AddFoodScreen
import one.healthium.log_food.ui.find_food.FindFoodScreen
import one.healthium.log_food.ui.navigation.LogFoodComponent
import one.healthium.ui.compose.components.AppSheetTopBar
import org.jetbrains.compose.resources.stringResource

@Composable
fun LogFoodContent(component: LogFoodComponent) {
    Column(Modifier.testTag("log_food_screen")) {
        AppSheetTopBar(
            title = {
                Text(stringResource(loco.Res.string.LOG_FOOD_ADD_MEAL_SCREEN_TITLE))
            },
            onCloseClicked = component::onCloseClicked,
        )
        Children(
            stack = component.stack,
            animation = stackAnimation(slide())
        ) {
            CompositionLocalProvider(
                LocalViewModelStoreOwner provides component
            ) {
                when (val child = it.instance) {
                    is LogFoodComponent.Child.FindFood -> FindFoodScreen(child.component)
                    is LogFoodComponent.Child.AddFood -> AddFoodScreen(child.component.food, child.component, component.taskId)
                }
            }
        }
    }
}